// extracted by mini-css-extract-plugin
module.exports = {"overline":"Activity_overline__2mS_4","title":"Activity_title__13dnr"};